import { Injectable } from '@angular/core';

import { ipcRenderer, webFrame, remote } from 'electron';
import * as childProcess from 'child_process';
import * as fs from 'fs';
import * as SerialPort from 'serialport';
// import * as parserReady from '@serialport/parser-ready';

@Injectable()
export class ElectronService {

  ipcRenderer: typeof ipcRenderer;
  webFrame: typeof webFrame;
  remote: typeof remote;
  childProcess: typeof childProcess;
  fs: typeof fs;
  //serialPort: typeof SerialPort;
  // parserReady: typeof parserReady;

  constructor() {
    // Conditional imports
    if (this.isElectron()) {
      this.ipcRenderer = window.require('electron').ipcRenderer;
      this.webFrame = window.require('electron').webFrame;
      this.remote = window.require('electron').remote;

      this.childProcess = window.require('child_process');
      this.fs = window.require('fs');

      //this.serialPort = window.require('serialport');
      // this.parserReady = window.require('parserReady');
    }
  }

  isElectron = () => {
    return window && window.process && window.process.type;
  }

  closeApplication = () => {
    if(this.isElectron()) {
      this.ipcRenderer.send('quitApplication');
    }
  }

  getUsbDevices = () => {
    return new Promise((resolve, reject) => {
      if (this.isElectron()) {
        this.ipcRenderer.send('getUsbDevices', true);
        this.ipcRenderer.on('usbDevices', (event, devices) => {
          // console.log('[ DEBUG ] Devices Available:', devices);
          resolve(devices);
        });
      } else {
        reject('Browser Mode. Electron Mode required.');
      }

    });
  }

  readUsbDevice = (device) => {
    return new Promise((resolve, reject) => {
      if (this.isElectron()) {
        this.ipcRenderer.send('selectUsbDevice', { VID: device.vendorId, PID: device.productId });
        this.ipcRenderer.on('selectedDevice', (event, data) => {
          resolve(data);
        });
      } else {
        reject('Browser Mode. Electron Mode required.');
      }
    });
  }

  getSerialPorts = () => {
    return new Promise((resolve, reject) => {
      if (this.isElectron()) {
        this.ipcRenderer.send('getSerialPorts', true);
        this.ipcRenderer.on('serialPorts', (event, ports) => {
          console.log('[ DEBUG ] Ports Available:', ports);
          resolve(ports);
        });
      } else {
        reject('Browser Mode. Electron Mode required.');
      }
    });
  }

  readSerialPort = (port, options) => {
    return new Promise((resolve, reject) => {
      if (this.isElectron()) {
        // Closing the port anyway after 3 second to avoid hanging for a response
        setTimeout(() => {
          this.closeSerialPort().then(() => {
            reject('Operation Timed Out');
          });
        }, 3000);
        const payload = {...options, ...port};
        console.log('[ DEBUG ] Sending Service Payload to Electron:', payload);
        this.ipcRenderer.send('selectSerialPort', payload);
        this.ipcRenderer.on('serialRead', (event, data) => {
          console.log(event);
          console.log(data);
          resolve(data);
        });
      } else {
        reject('Browser Mode. Electron Mode required.');
      }
    });
  }

  closeSerialPort = () => {
    return new Promise((resolve, reject) => {
      if (this.isElectron()) {
        this.ipcRenderer.send('closeSerialPort');
        this.ipcRenderer.on('serialClosed', () => {
          resolve(true);
        });
      } else {
        reject('Browser Mode. Electron Mode required.');
      }
    });
  }

  errorSerialPort = () => {
    return new Promise((resolve, reject) => {
      if (this.isElectron()) {
        this.ipcRenderer.on('serialError', (event, err) => {
          reject(err);
        });
      }
    })
  }
}
